import { FC } from 'react';
import { NumericFormat } from 'react-number-format';
import { FilledInputProps, InputAdornment, TextField } from '@mui/material';
import { getFormikValueWithSubFields } from 'src/util/utils';
import _ from 'lodash';

interface CurrencyFieldText {
  label: string;
  fieldName: string;
  fieldList?: string[];
  size?: 'small' | 'medium';
  formik: any;
  placeholder?: string;
  inputProps?: Partial<FilledInputProps>;
  disabled?: boolean;
  currency: '€' | '$' | '£' | '%';
  hideHelperText?: boolean;
}

export const CurrencyFieldText: FC<CurrencyFieldText> = ({
  label,
  fieldName,
  formik,
  placeholder,
  disabled,
  currency,
  size,
  hideHelperText,
  fieldList,
}) => {
  let fieldValue: any;
  if (fieldList) {
    fieldValue = getFormikValueWithSubFields(formik.values, fieldList);
  } else {
    fieldValue = _.get(formik.values, fieldName);
  }
  if (fieldValue && (typeof fieldValue === 'string' || fieldValue instanceof String)) {
    fieldValue = fieldValue?.replace(/\./g, ',') || fieldValue;
  }

  return (
    <NumericFormat
      customInput={TextField}
      margin="normal"
      label={label}
      type="text"
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      decimalScale={2}
      decimalSeparator=","
      size={size}
      value={fieldValue}
      onValueChange={(values) => {
        formik.setFieldValue(fieldName, values.floatValue);
      }}
      error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
      helperText={!hideHelperText ? (formik.touched[fieldName] && formik.errors[fieldName]) ?? ' ' : ''}
      disabled={disabled}
      thousandSeparator={false}
      inputProps={{ 'data-cy': fieldName + '-field' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            {currency}
          </InputAdornment>
        ),
      }}
    />
  );
};
